/**
 * LatestNewsItemBlock
 */

import React from 'react';
import { Cell } from 'components/Grid';
import { Card } from 'components/Cards';
import { LatestNewsPageCardModel } from 'types/cards';
import { useMediaQuery } from 'react-responsive';
import { breakpointsNumber } from 'theme/media-queries';

type Props = {
	/** Background color */
	backgroundColor?: 'lightBlue' | 'blue' | 'white';

	/** Card index */
	index: number;

	/** Card model */
	cardModel: LatestNewsPageCardModel;

	showAsList?: boolean;
};

/** LatestNewsItemBlock */
const LatestNewsItemBlock: React.FC<Props> = ({
	backgroundColor,
	index,
	cardModel,
	showAsList,
}) => {
	const isPhone = useMediaQuery({
		maxWidth: breakpointsNumber.tablet - 1,
	});
	console.log('Rendering LatestNewsItemBlock:', { index, cardModel });
	return (
		<Cell span={isPhone || showAsList ? 12 : 4}>
			<Card
				backgroundColor={backgroundColor}
				cardModel={cardModel}
				index={index}
				showAsList={showAsList}
				isLatestNewsItem
			/>
		</Cell>
	);
};

export default LatestNewsItemBlock;
